import request from "@/utils/request"

export const getArt = params =>{
  return request({
    method:'GET',
    url:'/art',
    params
  })
}

export const getDynamic = params =>{
  return request({
    method:'GET',
    url:'/dynamic',
    params
  })
}

//报名

export const postJoinAdd = data =>{
  return request({
    method:'POST',
    url:'/join/add',
    data
  })
}

export const getContact = params =>{
  return request({
    method:'GET',
    url:'/contact',
    params
  })
}